export const environment = {
    production: true,
    hmr: false,
    gqlLink: 'https://gql.spekwo.com/graphql',
    website: 'https://www.spekwo.com/',
    displayWebsite: 'www.spekwo.com',
    email: 'hello@spekwo.com',
    apiHost: 'https://api.spekwo.com/',
    customerUrl: 'https://client.spekwo.com/',
    displayCusUrl: 'client.spekwo.com '
};



// WEBPACK FOOTER //
// /vercel/path0/src/environments/environment.ts